export default "__VITE_ASSET__BAm$Gc8D__"